<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Аналитика') }}</h1>
    <div class="my-organization">
      <div class="analytics-pg bgw-pdg-20">
        <h4 class="title-pg-default text-center">{{ $t('Сводные отчеты по численности основных охотничьих и занесенных в Красную книгу животных, обитающих в охотничьих угодьях Кыргызстана')}}</h4>
        <div class="search-head">
          <v-row justify="center">
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Область') }}</v-label>
              <div class="select-def">
                <v-select
                  item-value="id"
                  item-text="name"
                  :items="soates"
                  v-model="search.soateId"
                  required
                  outlined
                  dense
                  clearable
                  @change="setSoateName"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Организации') }}</v-label>
              <div class="select-def">
                <v-select
                  item-value="id"
                  item-text="name"
                  :items="oopts"
                  v-model="search.ooptId"
                  required
                  outlined
                  dense
                  clearable
                  @change="setOoptName"
                />
              </div>
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="fetchData"
            >
              {{ $t('Генерировать отчет') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="fetchData(true)"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
          <div class="hint">
            <p><span v-if="soateName">{{ $t('Область') }}: {{ soateName }}</span> <span v-if="ooptName">{{ $t('Организация') }}: {{ ooptName }}</span></p>
          </div>
        </div>
        <div class="search-body">
          <FaunaSummaryReport :years="years" ref="faunaSummaryReport"/>
          <v-btn @click="printWord" class="btn-print-word">{{ $t("Печать в Word") }}</v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Api from '@/model/api'
import FaunaSummaryReport from '@/components/app/FaunaSummaryReport'

export default {
  components: {
    FaunaSummaryReport
  },
  data: () => ({
    breadcrumbs: [],
    search: {},
    data: [],
    oopts: [],
    soates: [],
    years: [],
    columnData: [],
    columnOptions: [],
    graphicDialog: [],
    soateName: null,
    ooptName: null
  }),
  created () {
    this.searchFormData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    searchFormData () {
      this.setLoading(true)
      Api.getAnimalAccountingFaunasYearFormData()
        .then((response) => {
          this.soates = response.data.soates
          this.oopts = response.data.oopts
          this.years = response.data.years
          this.fetchData(true)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    fetchData (reset = false) {
      if (reset === true) {
        this.search = {}
        this.soateName = null
        this.ooptName = null
      }
      this.$refs.faunaSummaryReport.fetchData(this.search)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Аналитика'),
          disabled: true
        }
      ]
    },
    setSoateName () {
      const soate = this.soates.find(x => x.id === this.search.soateId)
      this.soateName = soate ? soate.name : null
    },
    setOoptName () {
      const oopt = this.oopts.find(x => x.id === this.search.ooptId)
      this.ooptName = oopt ? oopt.name : null
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'аналитика.docx')
      document.body.appendChild(link)
      link.click()
    },
    // печать в ворд
    printWord () {
      this.setLoading(true)
      Api.printCountSummaryReport(this.search)
        .then(res => {
          if (res.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(res)
          }
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })

      this.setLoading(false)
    }
  }
}
</script>

<style scoped>
.analytics-pg .search-head .hint {
  margin: 20px 0 0;
}
</style>
